import styled, { css } from 'styled-components'

import { Button } from '../../styles/global'

export const Header = styled.div`
  color:#fff;
  font-size:13px;
  font-weight:700;
  border-radius:8px 8px 0 0;
  padding:8px 10px;
  ${props => props.isPast ? 'background:#8BC7CE;' : 'background:#1E8B98;'}
  display: flex;
`
export const SchedulerTime = styled.span`
  padding-top: 3px;
`
export const NotificationCircle = styled.span`
  border-radius: 50%;
  width: 21px;
  height: 21px;
  padding: 3px;
  background: #FF8300;
  color: #FFF;
  text-align: center;
  margin-left: auto;
`
export const Body = styled.div`
  display:flex;
  flex-direction:column;
  padding:8px 16px;
  overflow:hidden;
  background:#fff;
`
export const Item = styled.div`
  display:flex;
  align-items:center;
  color: #01878E;
  font-family: 'Open Sans';
  font-style: normal;
  font-size:14px;
  font-weight:700;
  border-bottom:1px solid #4FD3DE;
  padding:5px;

  &.with-no-border{
    border:none;
  }
`
export const Icon = styled.div`
  background:#FFEDD6;
  border-radius:50%;
  width:40px;
  height:40px;
  color:#F27D0052;
  margin-right:10px;
  overflow:hidden;
  display:flex;
  align-items:center;
  justify-content:center;

  img{
    max-width:100%;
  }
`
export const Description = styled.div`
  min-height: ${props => props.minHeight ? `${props.minHeight}px` : 'auto'};
  width: 70%;
`

export const Question = styled.div`
  font-size: 13px;
  color: #FD8323;
  font-weight: normal;
`
export const PendingAnswer = styled.div`
  font-size: 13px;
  color: #707070;
  font-weight: normal;
  margin-top: 4px;
`
export const QuestionContent = styled(Item)`
  background-color: #FFEDD6;
  padding: 5px 10px;
  border: none;
  align-items: flex-start;

  .flex-column {
    flex-direction: column;
    margin-top: 5px;
  }
`
export const TextAreaContent = styled(Item)`
  flex-direction: column;
  padding: 15px 0px 0px 0px;
  border: none;
`

export const MaxCaracters = styled.div`
  align-self: flex-end;
  color: #777;
  font-weight: normal;
`
export const Footer = styled.div`
  display:flex;
  border-radius:0 0 8px 8px;
  padding:0 0 5px 0;
  background: #fff;
`
export const ButtonOpen = styled.button`
  margin:0 auto;
  border:none;
  background:none;
`
export const ButtonSubmit = styled(Button)`
  background-color: #01878E;
  margin: 5px 0px;
`
export const AdditionalServices = styled.span`
  font-weight: 400;
  display: block;
  ${({ open }) => open === false && css`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    -webkit-line-clamp: 1;
  `}
`
